import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const benefits = [
  { icon: 'Zap', title: 'EFEKTIVITA', detail: '5ks/m²', desc: 'Díky vysokému výkonu minimalizujete počet světelných zdrojů při zachování dokonalého jasu.' },
  { icon: 'DollarSign', title: 'EKONOMIKA', detail: 'od 300Kč/m²', desc: 'Bezkonkurenční cena za metr čtvereční plochy (platí pro 9,6W variantu při rozteči 20cm). Nízká spotřeba energie šetří vaše provozní náklady.' },
  { icon: 'Activity', title: 'VÝKON', detail: '6250lm/m²', desc: 'Vysoká svítivost, která zajistí perfektní prozáření i pro hluboké světelné boxy (platí pro 9,6W variantu při rozteči 20cm).' },
  { icon: 'Clock', title: 'ŽIVOTNOST', detail: '50 000h', desc: 'Využití špičkových čipů SANAN zaručuje barevnou stabilitu a plný výkon po celé roky.' },
  { icon: 'ShieldCheck', title: 'ZÁRUKA', detail: '5 let', desc: 'Za kvalitou našich produktů si stojíme, proto poskytujeme nadstandardní pětiletou záruku.' },
  { icon: 'Link', title: 'RYCHLOST', detail: 'Instalace v minutách', desc: 'Systém GRID (žebřík) umožňuje bleskovou montáž bez nutnosti složitého propojování.' }
];

const CoreBenefits = () => {
  return (
    <section id="vyhody" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 italic tracking-tighter uppercase">Hlavní výhody LEDBARS</h2>
          <div className="w-24 h-1.5 bg-blue-600 mx-auto rounded-full"></div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {benefits.map((b, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }} className="group p-8 bg-gray-50 rounded-3xl hover:bg-blue-600 transition-all duration-500 border border-gray-100 hover:shadow-2xl hover:shadow-blue-600/20">
              <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center mb-6 text-blue-600 group-hover:bg-blue-500 group-hover:text-white transition-colors duration-500 shadow-sm"><SafeIcon name={b.icon} className="w-8 h-8" /></div>
              <h3 className="text-2xl font-bold text-gray-900 group-hover:text-white mb-2 uppercase tracking-tight">{b.title}</h3>
              <div className="text-blue-600 group-hover:text-blue-200 font-bold mb-4 text-xl">{b.detail}</div>
              <p className="text-gray-600 group-hover:text-blue-50 leading-relaxed">{b.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoreBenefits;